import Axios from "./axios"  // 导入配置好的axios文件
import store from '../../store'
import { Message} from 'element-ui';

import { Base64 } from '../uploadImg/base64.js';
import Crypto from '../uploadImg/crypto.js';
import '../uploadImg/hmac.js';
import '../uploadImg/sha1.js';
// 封装axios请求函数，并用export导出

// get请求
export function get(apiUrl,datas) {
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "get",
			url: apiUrl,
			headers: {
				'Content-Type': 'application/json;' 
			},
			params:datas,
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
// put请求
export function put(apiUrl,datas) {
    
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "put",
			url: apiUrl,
			
			data:datas,
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
// delete请求
export function deleteP(apiUrl,datas) {
    
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "delete",
			url: apiUrl + '/' + datas,
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
// delete请求
export function deletes(apiUrl,datas) {
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "delete",
			url: apiUrl,
			data:datas,
		}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}

// 拼接
export function getJ(apiUrl,datas) {
    return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "get",
			url: apiUrl+datas,
			headers: {
				'Content-Type': 'application/json;' 
			},
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}
// 请求头'Content-Type': 'application/json'
export function postP(apiUrl,datas) {
	return new Promise((resolve,reject) => {
		Axios.Axios({
			method: "post",
			url: apiUrl,
			headers: {
				'Content-Type': 'application/json;charset=UTF-8' 
			},
			data:datas,
			transformRequest: [function () {
				// 对 data 进行任意转换处理
				return JSON.stringify(datas);
			  }],
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}




//上传
export function upload(apiUrl,file,params) {
	const param = new FormData() // 创建form对象
	param.append('file', file);
	// param.append('id', "zcpg");
	if (params) {
		for (let key in params) {
		  param.append(key, params[key])// 通过append向form对象添加数据
		}
	}
	return new Promise((resolve,reject) => {
		return Axios.localAxios({
		method: "post",
		url: apiUrl,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data:param, 
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return param;
		}],
		}).then(res=>{
			console.log(res);
			resolve('http://47.112.123.229:8003/'+res.data.data.fileUrl);
		}).catch(err=>{
			reject(err);
		})
	})
	
}






// 返回时间日期
function formatDate(value,boolean) {
	let date = new Date(value);
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m;
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	if(boolean){
		return y + '' + MM + '' + d
	}else{
	  return y + '' + MM + '' + d + '' + h + '' + m + '' + s;
	}
}
  // 生成随机数
function random_string(len) {
	len = len || 32;
	var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
	var maxPos = chars.length;
	var pwd = '';
	for (let i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}
//上传http://txggpic.oss-cn-shenzhen.aliyuncs.com
export function uploadOther(apiUrl,file,params) {
	let imgLists = [];
	var uploadFileSize = 1024 * 1024 * 1024; // 上传文件的大小限制100m
	var policyText = {
		"expiration": "2030-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
		"conditions": [
			["content-length-range", 0, uploadFileSize] // 设置上传文件的大小限制 
		]
	};
	var accessid = 'LTAI0bbg7dKrg1uD';
	var accesskey = 'zG0zsvE5P8VxZ0ZlYJRYqiPiCCsXgn';
	var osshost = 'https://txggpic.oss-cn-shenzhen.aliyuncs.com';
	var policyBase64 = Base64.encode(JSON.stringify(policyText));
	var message = policyBase64;
	var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, {
		asBytes: true
	});
	var signature = Crypto.util.bytesToBase64(bytes);
	var timetamp = new Date().getTime();

	console.log('____');

	let stroeAs = formatDate(timetamp,true) +'/' + formatDate(timetamp,false) + random_string(5);
	console.log(stroeAs);

	const param = new FormData() // 创建form对象
	param.append('key', stroeAs);
	param.append('policy', policyBase64);
	param.append('OSSAccessKeyId', accessid);
	param.append('success_action_status', '200');
	param.append('signature', signature);
	param.append('reportno', '');
	param.append('file', file);
	if (params) {
		for (let key in params) {
		  param.append(key, params[key])// 通过append向form对象添加数据
		}
	}
	return new Promise((resolve,reject) => { 
		return Axios.OtherAxios({
		method: "post",
		url: apiUrl,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data:param, 
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return param;
		}],
		}).then(res=>{
			resolve(osshost + '/' + stroeAs);

		}).catch(err=>{
			// resolve(osshost + '/' + stroeAs);
		})
	})
	
}

export function uploadOtherSort(apiUrl,file,params) {
	let imgLists = [];
	var uploadFileSize = 1024 * 1024 * 100; // 上传文件的大小限制100m
	var policyText = {
		"expiration": "2052-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
		"conditions": [
			["content-length-range", 0, uploadFileSize] // 设置上传文件的大小限制 
		]
	};
	var accessid = 'LTAI0bbg7dKrg1uD';
	var accesskey = 'zG0zsvE5P8VxZ0ZlYJRYqiPiCCsXgn';
	var osshost = 'https://txggpic.oss-cn-shenzhen.aliyuncs.com';
	var policyBase64 = Base64.encode(JSON.stringify(policyText));
	var message = policyBase64;
	var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, {
		asBytes: true
	});
	var signature = Crypto.util.bytesToBase64(bytes);
	var timetamp = new Date().getTime();

	console.log('____');

	let stroeAs = formatDate(timetamp,true) +'/' + formatDate(timetamp,false) + random_string(5) + '.jpg' ;
	console.log(stroeAs);

	const param = new FormData() // 创建form对象
	param.append('key', stroeAs);
	param.append('policy', policyBase64);
	param.append('OSSAccessKeyId', accessid);
	param.append('success_action_status', '200');
	param.append('signature', signature);
	param.append('reportno', '');
	param.append('file', file);
	if (params) {
		for (let key in params) {
		  param.append(key, params[key])// 通过append向form对象添加数据
		}
	}
	return new Promise((resolve,reject) => { 
		resolve(osshost + '/' + stroeAs);
		return Axios.OtherAxios({
		method: "post",
		url: apiUrl,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data:param, 
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return param;
		}],
		}).then(res=>{
  			store.dispatch('global/setIsUploadImgEnd', true);
		}).catch(err=>{
			console.log('___________________________');
  			store.dispatch('global/setIsUploadImgEnd', !store.getters['global/s_isUploadImgEnd']);
			console.log(store.getters['global/s_isUploadImgEnd']);
			console.log(store.state.global.isUploadImgEnd);
		})
	})
	
}

export function getExcel(apiUrl,datas,name) {
	console.log(datas);
	let downloadName = name;
	
			
	return new Promise((resolve,reject) => {
		return Axios.Axios({
		method: "POST",
		url: apiUrl,
		headers: {
			'Content-Type': 'application/json;application/octet-stream;charset=utf-8'
		},
		data:datas,
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return JSON.stringify(datas);
		}],
		responseType: 'blob',
		}).then(res=>{
			var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
			const downloadElement = document.createElement('a');
			let href = window.URL.createObjectURL(blob);
			downloadElement.href = href;
			downloadElement.setAttribute('download', downloadName);
			document.body.appendChild(downloadElement);
			downloadElement.click();
			document.body.removeChild(downloadElement); // 下载完成移除元素
			window.URL.revokeObjectURL(href); // 释放掉blob对
			resolve(res);
		}).catch(err=>{
			reject(err);
		})
	})
}


export function postPackage(apiUrl,datas){
	console.log(datas);
	let downloadName = datas.zipName;
	return new Promise((resolve,reject) => {
		return Axios.Axios({
		method: "GET",
		url: apiUrl,
		headers: {
			'Content-Type': 'application/json;application/octet-stream;charset=utf-8'
		},
		data:datas,
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return JSON.stringify(datas);
		}],
		responseType: 'blob',
		}).then(res=>{
			// console.log(res.data);
			// const elt = document.createElement('a');
            // elt.setAttribute('target', '_blank');
            // elt.setAttribute('href', res.data.data.uploadPath);
            // elt.setAttribute('download', downloadName);
            // elt.style.display = 'none';
            // document.body.appendChild(elt);
            // elt.click();


			var blob = new Blob([res.data], {type: 'application/zip'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
			const downloadElement = document.createElement('a');
			let href = window.URL.createObjectURL(blob);
			downloadElement.href = href;
			downloadElement.setAttribute('download', downloadName);
			document.body.appendChild(downloadElement);
			downloadElement.click();
			document.body.removeChild(downloadElement); // 下载完成移除元素
			window.URL.revokeObjectURL(href); // 释放掉blob对
			resolve(res);
		}).catch(err=>{
			reject(err);
		})
	})
}


export function getPDF(apiUrl,datas,name) {
	console.log(datas);
	let downloadName = name;
	return new Promise((resolve,reject) => {
		return Axios.localAxios({
		method: "POST",
		url: apiUrl,
		headers: {
			'Content-Type': 'application/json;application/octet-stream;charset=utf-8'
		},
		data:datas,
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return JSON.stringify(datas);
		}],
		responseType: 'blob',
		}).then(res=>{
			console.log(res);
			if(res.data.code){
				if(res.data.code != '200'){
					Message({
						message: res.data.msg,
						type: 'warning'
					});
					return;
				}
			}
			
			var blob = new Blob([res.data], {type: 'application/pdf'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
			const downloadElement = document.createElement('a');
			let href = window.URL.createObjectURL(blob);
			downloadElement.href = href;
			downloadElement.setAttribute('download', downloadName);
			document.body.appendChild(downloadElement);
			downloadElement.click();
			document.body.removeChild(downloadElement); // 下载完成移除元素
			window.URL.revokeObjectURL(href); // 释放掉blob对
			resolve(res);
		}).catch(err=>{
			reject(err);
		})
	})
}

export function createPDF(apiUrl,datas) {
	console.log(datas);
	return new Promise((resolve,reject) => {
		return Axios.localAxios({
		method: "POST",
		url: apiUrl,
		headers: {
			'Content-Type': 'application/json;application/octet-stream;charset=utf-8'
		},
		data:datas,
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return JSON.stringify(datas);
		}],
		responseType: 'blob',
		}).then(res=>{
			
			resolve(res);
		}).catch(err=>{
			reject(err);
		})
	})
}


// 请求头'Content-Type': 'application/json'
export function postOther(apiUrl,datas) {
	return new Promise((resolve,reject) => {
		Axios.localAxios({
			method: "post",
			url: apiUrl,
			headers: {
				'Content-Type': 'application/json;charset=UTF-8' 
			},
			data:datas,
			transformRequest: [function () {
				// 对 data 进行任意转换处理
				return JSON.stringify(datas);
			  }],
			}).then(res=>{
				resolve(res);
			}).catch(err=>{
				reject(err);
		})
	})
}

//导入excel
export function importExcel(apiUrl,file,params) {
	const param = new FormData() // 创建form对象
	param.append('file', file);
	// param.append('id', "zcpg");
	if (params) {
		for (let key in params) {
		  param.append(key, params[key])// 通过append向form对象添加数据
		}
	}
	return new Promise((resolve,reject) => {
		return Axios.Axios({
		method: "post",
		url: apiUrl,
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data:param, 
		transformRequest: [function () {
			// 对 data 进行任意转换处理
			return param;
		}],
		}).then(res=>{
			console.log(res);
			resolve(res);
		}).catch(err=>{
			reject(err);
		})
	})
	
}
